import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { fedopsLoggerService } from './fedopsLoggerService'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(fedopsLoggerService)
}

export const editor = site
